import { Wrapper } from '@googlemaps/react-wrapper';
import { type ReactNode } from 'react';


type GoogleMapsWrapperProps = {
	readonly children?: ReactNode;
};

const GoogleMapsWrapper = ({ children }: GoogleMapsWrapperProps) => {
	const apiKey = 'AIzaSyCvhyNmgCzGilzH40R63v4l_svk8uu5q3c';
	if (!apiKey) {
		return <div>Cannot display the map: google maps api key missing</div>;
	}
	return (
		<Wrapper apiKey={apiKey} libraries={['geometry', 'marker']}>
			{children}
		</Wrapper>
	);
};

export default GoogleMapsWrapper;
